import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
import {addLevelAddSchoolModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';

@Component({
  selector: 'addSubjectsS',
  templateUrl: 'prompts.component.html',
  styleUrls: ['prompts.component.scss'],

})
export class PromptsComponent implements OnInit {

  AddLevelAddSchoolModel = new addLevelAddSchoolModel();
  display = "none";
  display1 = "none";
  public schoolId: any;
  public userId: string;
  public promptData: any;

  public noOfPrompts: 0;

  public selectedlevel: string = "";
  public selectedlevelid: string = "";
  public selectedPromptId: string = "";
  public selectedPromptName: string = "";
  public selectedPromptTypeFormat: string = "";

  // In your component file
  ShowLevelData1 = [
    { prompt: 'Prompt 1' },
    { prompt: 'Prompt 2' },
    { prompt: 'Prompt 3' },
    { prompt: 'Prompt 4' },
    { prompt: 'Prompt 5' }
  ];


  constructor(
    private dataAnalyticsService: DataAnalyticsService,
    private messageService: MessageService,
    private noticeboardService: NoticeboardService,
    private confirmationService: ConfirmationService,
    private localStorage: LocalStorageService
  ) {
    this.schoolId = this.localStorage.retrieve("SchoolId");
    this.userId = this.localStorage.retrieve("id");
  }

  ngOnInit() {
    this.getAllPrompts();
  }
//-------------------------------------------------------GET----------------------------------------------------
  private getAllPrompts() {
    this.dataAnalyticsService
      .getPrompts()
      ._finally(() => {})
      .subscribe((response) => {
        const res = response as any;
        this.promptData = res.Value || null;
        this.noOfPrompts = this.promptData.length;
        console.log(this.noOfPrompts);
      });
  }
//-------------------------------------------------------Post----------------------------------------------------

  // Method to add a new prompt
  postLeveladdSchool() {
    // Ensure the prompt name and format are provided before posting
    if (!this.selectedPromptName || !this.selectedPromptTypeFormat) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please provide all required details."
      });
      return;
    }

    const payload = {
      schoolid: this.schoolId,
      [`PromptType${this.noOfPrompts+1}`]: this.selectedPromptName,
      [`PromptTypeFormat${this.noOfPrompts+1}`]: this.selectedPromptTypeFormat // Add format to payload if required
    };


    console.log(payload);

    this.dataAnalyticsService.postPrompt(payload).subscribe(
      (response) => {
        this.messageService.add({
          severity: "success",
          summary: "Prompt Management",
          detail: "Prompt added successfully."
        });
        this.display = "none";  // Hide modal
        this.getAllPrompts();    // Refresh prompt data
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to add prompt. Please try again."
        });
      }
    );
  }
  //-------------------------------------------------------Update----------------------------------------------------

  updateLeveladdSchool() {
    if (!this.selectedlevelid || !this.selectedPromptName || !this.selectedPromptTypeFormat) {
      this.messageService.add({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please provide all required details."
      });
      return;
    }


    const payload = {
      schoolid: this.schoolId,
      [`PromptTypeId${this.noOfPrompts+1}`]: this.selectedPromptId,
      [`PromptType${this.noOfPrompts+1}`]: this.selectedPromptName,
      [`PromptTypeFormat${this.noOfPrompts+1}`]: this.selectedPromptTypeFormat // Add format to payload if required
    };


    this.dataAnalyticsService.updatePropmt(payload).subscribe(
      (response) => {
        this.messageService.add({
          severity: "success",
          summary: "Prompt Management",
          detail: "Prompt updated successfully."
        });
        this.display1 = "none";  // Hide modal
        this.getAllPrompts();     // Refresh prompt data
      },
      (error) => {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to update prompt. Please try again."
        });
      }
    );
  }

  AddLevel() {
    this.display = "block";
  }

  EditLevel(level: any) {
    console.log(level);
    this.display1 = "block";
    this.selectedPromptName = level.Promptypename;
    this.selectedPromptId = level.Id;
    this.selectedPromptTypeFormat = level.Promtypefromat;

  }

  onCloseHandled() {
    this.display = "none";
    this.display1 = "none";
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/prompts/prompts.component.ts